import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Skeleton from '../../components/common/Skeleton';
import UnauthorizedPage from '../errors/UnauthorizedPage';

// Wrapper que protege rotas /admin-reviter. Só platform_admin passa.
const AdminGate = ({ children }) => {
  const { isAuthenticated, isPlatformAdmin, loading } = useAuth();

  if (loading) return <Skeleton variant="block" height={120} />;
  if (!isAuthenticated) return <Navigate to="/admin-reviter/login" replace />;
  if (!isPlatformAdmin) return <UnauthorizedPage />;
  return children;
};

export default AdminGate;
